import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Popup as PopupService } from '../../../core/services/popup';

@Component({
  selector: 'app-popup',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './popup.html',
  styleUrl: './popup.css'
})
export class Popup {
  private popupService = inject(PopupService); 

  popup = this.popupService.popup;

  popupClasses = computed(() => {
    const popup = this.popup();
    if (!popup) return '';

    const base =
      'rounded-full shadow-lg py-3 px-5 text-white flex items-center justify-between gap-3 transition-all duration-300 bg-(--text-secondary)';
    const color =
      popup.type === 'success'
        ? 'bg-(--text-secondary)'
        : popup.type === 'error'
        ? 'bg-red-600'
        : popup.type === 'warning'
        ? 'bg-yellow-500'
        : popup.type === 'info'
        ? 'bg-blue-500'
        : 'bg-gray-800';

    return `${base} ${color}`;
  });

  popupPosition = computed(() => {
    const popup = this.popup();
    if (!popup) return '';
    return popup.position === 'bottom'
      ? 'bottom-6'
      : popup.position === 'center'
      ? 'top-1/2 -translate-y-1/2'
      : 'top-6';
  });

  closePopup() {
    this.popupService.close();
  }
}
